import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getCurrentDocument } from '../../utils/helperUtil';
import { dataTrackwithDetail } from '../../utils/vzdl';

const StyledMenu = styled.div`
  padding: 5px;
  background-color: ${(props) => props?.$backgroundColor || '#f3f3f5'};
`;
const StyledItem = styled.a`
  padding: 2.5px 19px;
  display: block;
  font-size: 0.875rem;
  overflow: hidden;
  cursor: pointer;
  text-overflow: ellipsis;
  text-decoration: none;
  line-height: 1.6;
  font-family: Verizon-NHG-eTX, Helvetica, Ariel, sans-serif;
  white-space: nowrap;
  color: ${(props) => props?.$textColor};
  &.selected {
    border-radius: 4px;
    background-color: ${(props) => props?.$highlightColor};
    color: ${(props) => props?.$highlightTextColor};
  }
  &.selected_item {
    border-radius: 4px;
    font-weight: bold;
    background-color: transparent;
    color: ${(props) => props?.$textColor};
    &.selected {
      font-weight: normal;
      border-radius: 4px;
      background-color: ${(props) => props?.$highlightColor};
      color: ${(props) => props?.$highlightTextColor};
    }
  }
  &:hover {
    font-weight: normal;
    border-radius: 4px;
    background-color: ${(props) => props?.$highlightColor};
    color: ${(props) => props?.$highlightTextColor};
    outline: 0;
  }
`;
const StyledMenuWrapper = styled.div`
  position: ${(props) => (props.isPortal ? 'fixed' : 'absolute')};
  background-color: white;
  z-index: 9999999;
  ${(props) =>
    props.$dimensions
      ? `top: ${props.isPortal ? props.$dimensions?.y + props.$dimensions?.height : props.$dimensions?.height}px;
    left: ${props.isPortal ? props.$dimensions?.x : 0}px;
    width: ${props.$dimensions?.width}px;
    border-radius: 7px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    max-height: 8rem;
    overflow-x: hidden;
    overflow-y: auto;
    `
      : ''}
`;

const MenuWrapper = ({ items, dimensions, childrefs, dropdownRef, setShowModal, ...rest }) => {
  const getDocument = getCurrentDocument();
  const itemRefs = useRef([]);
  useEffect(() => {
    if (itemRefs.current?.length > 0) {
      getDocument.querySelector(`#dropdown-list-${rest.itemval}`).focus();

      if (itemRefs.current[0].current) {
        rest.clearSelection(rest.selectedValue);
      }
    }
  }, [itemRefs, rest.selectedValue]);
  const onSelectItem = (e, item, itemIndex) => {
    console.log('selectedItem', item);
    rest?.onSelectItem(item[rest.itemval], item);
    if (item[rest.itemval].toLowerCase().startsWith('show')) {
      rest.updateIndex(itemIndex);
    }
    setShowModal(false);
  };
  const renderMenu = (menus) => (
    <StyledMenu id={`dropdown-list-${rest.itemval}`} ref={dropdownRef} role="listbox" $backgroundColor={rest.menuStyles?.backgroundColor}>
      {menus?.map((item, index) => {
        itemRefs.current[index] = itemRefs.current[index] || React.createRef();
        childrefs.push(itemRefs.current[index]);
        return renderItem(item, itemRefs.current[index], index);
      })}
    </StyledMenu>
  );
  const renderItem = (item, refItem, index) => {
    let unitExp = '';
    const displayValue = item[rest.itemval];
    const isAppartmentUnit = rest?.itemval?.toLowerCase() === 'ntassublocation';
    if (displayValue === 'I can’t find my unit' || displayValue === "I don't live in a unit") {
      unitExp = displayValue;
    } else if (displayValue === 'Need Help') {
      unitExp = 'need help select';
    } else if (displayValue === 'Show more results') {
      unitExp = isAppartmentUnit ? 'apartment/unit-show more' : 'see more addresses in dropdown';
    } else if (displayValue === 'Show less results') {
      unitExp = isAppartmentUnit ? 'apartment/unit-show less' : 'see less addresses in dropdown';
    }
    if (unitExp) {
      if (rest?.loopQualApp.homeLQ) {
        unitExp = dataTrackwithDetail('link', unitExp, 'lq banner');
      } else if (rest?.loopQualApp.lq4) {
        unitExp = dataTrackwithDetail('link', unitExp, 'lq sticky bar');
      } else {
        unitExp = dataTrackwithDetail('link', unitExp, 'lq check avail');
      }
    }
    return (
      <StyledItem
        role="option"
        ref={refItem}
        tabIndex="0"
        id={`dropdown-${rest.itemval}-item-${index}`}
        onMouseOver={() => {
          rest.updateIndex(-1);
          rest.clearSelection();
        }}
        onClick={(e) => onSelectItem(e, item, index)}
        data-track={unitExp || rest?.datatracker}
        $textColor={rest?.menuStyles?.textColor}
        $highlightColor={rest?.menuStyles?.selectedColor}
        $highlightTextColor={rest?.menuStyles?.textSelectedColor}
      >
        {item[rest.itemval] || ''}
      </StyledItem>
    );
  };
  if (!dimensions) {
    return <></>;
  }

  return (
    <StyledMenuWrapper isPortal={rest.isPortal} ref={rest.menuWrapperRef} $dimensions={dimensions}>
      {renderMenu(items)}
    </StyledMenuWrapper>
  );
};

export default MenuWrapper;

MenuWrapper.propTypes = {
  items: PropTypes.array,
  dimensions: PropTypes.any,
  childrefs: PropTypes.array,
  dropdownRef: PropTypes.any,
  setShowModal: PropTypes.any,
};
